const config = {
    apiUrl: 'http://notowania-api.gazetaprawna.pl'
}

export default config;


// WEBPACK FOOTER //
// ./js/config.js